export const MobileMenu = (function() {
	'use strict';

	let $subMenuTrigger, $win, breakpoint;

	function init() {
		 $subMenuTrigger = $('.site-header__nav .menu-item-has-children > a');
		 $win = $(window);
		 breakpoint = 768;

		$subMenuTrigger.click(function(e){
			if ($(window).width() < breakpoint) {
				e.preventDefault();

				let $t = $(this),
						$subMenu = $t.siblings('.sub-menu');

				if ($t.hasClass('open')) {
					$t.removeClass('open');
					$subMenu.stop().slideUp();
				} else {
					$t.addClass('open');
					$subMenu.stop().slideDown();
				}
			}
		});
	}

	return {
		init: init
	};
})();
